import React, { forwardRef, type ForwardedRef } from 'react';
import { cn } from '@mentimeter/ragnar-tailwind-config';
import type { ClickableT } from './Clickable.types';
import {
  ClickableButton,
  ClickableLink,
  type ClickableButtonProps,
  type ClickableLinkProps,
} from './components';

export const Clickable = forwardRef<
  HTMLButtonElement | HTMLAnchorElement,
  ClickableT
>(({ className, ...props }, ref) => {
  const defaultClasses = [
    'flex',
    'flex-col',
    'flex-none',
    'w-auto',
    'items-start',
    'min-w-0',
    'min-h-0',
    'relative',
    'rounded-default',
    'bg-transparent',
    'no-underline',
    'appearance-none',
    'transition',
    'transition-all',
    'ease-in-out',
    'duration-[0.1s]',
    'cursor-pointer',
    'hover:opacity-60',
    'outline-transparent',
    'focus-visible:outline-solid',
    'focus-visible:outline-interactive-focused',
    'focus-visible:outline-offset-2',
    'focus-visible:outline-4',
  ];

  if ('href' in props) {
    return (
      <ClickableLink
        ref={ref as ForwardedRef<HTMLAnchorElement>}
        {...(props as ClickableLinkProps)}
        className={cn(defaultClasses, className)}
      />
    );
  }

  return (
    <ClickableButton
      ref={ref as ForwardedRef<HTMLButtonElement>}
      {...(props as ClickableButtonProps)}
      className={cn(defaultClasses, className)}
    />
  );
});

Clickable.displayName = 'Clickable';
